import {Observable} from "rxjs/Rx";
import {DashboardUser, LoginOperator, GroupPermission} from "../../generated/protocol";
import {HttpService, HTTP_SERVICE_NAME} from "./http/HttpService";
import {AppCtx} from "../ioc/ApplicationContext";
import {injectable} from "inversify";
import {MENU_SERVICE_NAME, MenuService} from "./MenuService";

export const DASHBOARD_USER_SERVICE_NAME = "dashboardUserService";

export interface DashboardUserService {

    loadUserInfo(): Promise<DashboardUser>;

    getUser(): Observable<DashboardUser>;

    logout(): Promise<{}>;

    getLoginOperators(): Promise<LoginOperator[]>;

    getGroupsByUser(): Promise<{ [key: string]: GroupPermission }>;

    saveOperator(operatorId: number, operatorName: string);

    getSavedOperatorId(): number;

    getSaveOperatorName(): string;

    hasSavedOperator();

    clearOperator();

    hasPermission(categories: string[], requiresWriteAccess: boolean): boolean;
}

@injectable()
export class DashboardUserServiceImpl implements DashboardUserService {

    private http: HttpService;

    private _user: Observable<DashboardUser>;
    private userObserver: any;

    constructor() {
        this.http = AppCtx.resolve<HttpService>(HTTP_SERVICE_NAME)
        this._user = new Observable(observer => this.userObserver = observer);
    }

    getLoginOperators(): Promise<LoginOperator[]> {
        return this.http.doGet<LoginOperator[]>("/dashboard-user/login-operators");
    }

    saveOperator(operatorId: number, operatorName: string) {
        localStorage.setItem("loginOperatorId", "" + operatorId);
        localStorage.setItem("loginOperatorName", operatorName);
    }

    getSavedOperatorId(): number {
        return parseInt(localStorage.getItem("loginOperatorId"));
    }

    getSaveOperatorName(): string {
        return localStorage.getItem("loginOperatorName");
    }

    hasSavedOperator() {
        var item = localStorage.getItem("loginOperatorId");
        return typeof (item) != "undefined" && item != null && !isNaN(parseInt(item));
    }

    clearOperator() {
        localStorage.removeItem("loginOperatorId");
        localStorage.removeItem("loginOperatorName")
    }

    loadUserInfo(): Promise<DashboardUser> {
        return this.http.doGet<DashboardUser>("/dashboard-user/info");
    }

    logout(): Promise<{}> {
        return this.http.doGet<{}>("/dashboard-user/logout");
    }

    getGroupsByUser(): Promise<{ [key: string]: GroupPermission }> {
        return this.http.doGet("/dashboard-user/group-permissions");
    }

    getUser(): Observable<DashboardUser> {
        return this._user;
    }

    hasPermission(categories: string[], requiresWriteAccess: boolean) {
        let menuService = AppCtx.resolve<MenuService>(MENU_SERVICE_NAME);
        let userStore = AppCtx.getUserStore().getState();

        return menuService.hasPermission(categories, requiresWriteAccess, userStore.permissions);
    }
}


// WEBPACK FOOTER //
// ./src/app/service/DashboardUserService.ts